import React from 'react';
import { Col } from "reactstrap";
import {useHistory} from "react-router-dom";

const PaginaDireitaAutoridade = React.lazy( () => import("../../../components/Home/PaginaDireitaAutoridade"))
/**
 *
 * @param itensConsulta
 * @returns {JSX.Element}
 * @constructor
 */
const ConteudoPesquisaAutoridade = ({ itensConsulta }) => {
    const history = useHistory();
    return (
        <Col xs="12" md="12" className="pr-0">
            <PaginaDireitaAutoridade
                itensConsulta={itensConsulta}
                history={history}/>
        </Col>)
}

export default ConteudoPesquisaAutoridade;
